import {
    FETCH_HOME_DATA_REQUEST,
    FETCH_HOME_DATA_SUCCESS,
    FETCH_HOME_DATA_FAILURE
} from "../types";

const initialState = {
    homeData: null,
    // tourData: null,
    isLoading: false,
    error: null,
    status: "idle",
};

const homeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_HOME_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
                status: "pending"
            };
        case FETCH_HOME_DATA_SUCCESS:
            return {
                ...state,
                homeData: action.payload,
                // tourData: action.payload?.tour_data,
                isLoading: false,
                status: "success"
            };
        case FETCH_HOME_DATA_FAILURE:
            return {
                ...state,
                homeData: null,
                // tourData: null,
                error: action.payload,
                isLoading: false,
                status: "failed"
            };
        default:
            return state;
    }
};

export default homeReducer;
